<div [class]="tag.matchSearch ? 'feTagMatch' : 'feTag'" [class.leadMode]="leadMode"
     [innerHTML]="sanitizer.bypassSecurityTrustHtml(Utils.getHighlightedText(tag.label, keywords))">
</div>
